import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import { registerLicense } from '@syncfusion/ej2-base';

import router from "./router";
import store from "./store";
import config from "./config";
import vuetify from "./plugins/vuetify";
import fetch from "./plugins/fetch";
import utils from "./plugins/utility";
import url from "./plugins/url";
import c from "./plugins/consts";
import VueSweetalert2 from "vue-sweetalert2";
import productConst from "./components/product/ProductConst";
import productutils from "./plugins/productutils";
import "sweetalert2/dist/sweetalert2.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faFilePdf,
  faFileCode,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

Vue.use(VueSweetalert2);
library.add(faUserSecret);
library.add(faFilePdf);
library.add(faFileCode);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueRouter);

Vue.config.productionTip = false;
Vue.prototype.$utils = utils;
Vue.prototype.$config = config;
Vue.prototype.$fetch = fetch;
Vue.prototype.$url = url;
Vue.prototype.$c = c;
Vue.prototype.$productConst = productConst;
Vue.prototype.$productutils = productutils;
registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXxedHRUQ2hYV0R0XEc='); 

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(
    document.querySelectorAll("[data-vue-router-controlled]")
  ).map((el) => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
